// Module
var code = "<a href=\"#\" class=\"collection-item\" data-id=\"{{id}}\"> <i style=\"color:{};\" class=\"material-icons\">{{icon}}</i> {{id}} </a> ";
// Exports
export default code;